import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const useInstitutionsQueryOptions = (careerId) => {
  const queryFn = useApiRequest({
    url: "/institutions",
    params: { career_id: careerId },
    method: HttpMethod.Get,
  });

  return {
    queryKey: ["institutions", careerId],
    queryFn,
    enabled: !!careerId,
  };
};

export const useInstitutions = (careerId) => {
  return useQuery(useInstitutionsQueryOptions(careerId));
};
